import { useState } from 'react'
import { Asset, kuiperClassNames } from '@opallabs/kuiper'
import { SingleAssetPicker } from '../../../../../SingleAssetPicker'
import { getPickerArgs } from '../../constants'
import { SlideProps } from '../../types'
import { styles } from './styles'

export const DesktopSlide: React.FC<SlideProps> = ({
  assets = [],
  index,
  isDragging,
  isPresenting,
  isSnapshot,
  modules,
  onDragDrop,
  onExpandAsset,
  onRemoveAsset,
  onShowAssetPicker,
  readOnly,
}) => {
  const photo = assets.length ? assets[0] : null
  const [isHovered, setIsHovered] = useState(false)
  const pickerArgs = getPickerArgs(index, modules.length)

  return (
    <div
      css={styles.getSlideStyles(Boolean(photo))}
      className={kuiperClassNames('tiktok tiktok-carousel-slide')}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {photo ? (
        <Asset
          assetReference={photo}
          disableCoverAsset={false}
          hasAssetOverlay={!isSnapshot}
          imageFit="contain"
          isHovered={isHovered}
          placeholder={false}
          preview={isSnapshot}
          readOnly={readOnly}
          removeable={!isPresenting}
          onEmbiggen={() => onExpandAsset(photo.id || 0)}
          onRemove={() => onRemoveAsset(photo.id || 0)}
        />
      ) : (
        <SingleAssetPicker
          allowedUploadTypes={pickerArgs.allowMultiple}
          disableDrop={isDragging}
          onDragDrop={(e) => onDragDrop(e, pickerArgs)}
          onShowAssetPicker={() => onShowAssetPicker(pickerArgs)}
          readOnly={readOnly}
          style={styles.picker}
          uploadType={pickerArgs.uploadType}
        />
      )}
    </div>
  )
}
